var ANIMATION_DURATION = 300;
var C = {
	ANIMATION_DURATION: ANIMATION_DURATION
};

export { ANIMATION_DURATION, C as default };
